import { gql } from '@apollo/client';

export default gql`
  query getGroupEventEvents($id: ID!) {
    getGroupEvent(id: $id) {
      id
      events {
        edges {
          node {
            id
            type
            startTimestamp
            endTimestamp
            title
            clientFirstName
            clientLastName
            clientId
            staffId
            closed
            groupEventId
            staffAttending
            ... on CourtDateEvent {
              attendanceInfo @client
              location {
                id
                addressLine1
                city
                state
                zip
              }
              room {
                id
                description
              }
              attended {
                id
                outcomeId
                name
              }
              outcome {
                outcomeUid
                status
              }
            }
            ... on OfficeEvent {
              attendanceInfo @client
              location {
                id
                addressLine1
                city
                state
                zip
              }
              room {
                id
                description
              }
              attended {
                id
                outcomeId
                name
              }
              outcome {
                outcomeUid
                status
              }
            }
            ... on CheckInEvent {
              isCompleted
              submittedTimestamp
              checkInTemplate {
                id
                staffDisplayName
              }
              checkInReport {
                id
              }
            }
          }
        }
      }
    }
  }
`;
